import {
  snapSiteConfigSelectors,
  SnapSiteConfigState,
} from '@ui/features/snap-site-config/state';

import { useSelector } from '../useSelector';

export function useCurrentSite(): SnapSiteConfigState {
  const currentSite = useSelector(snapSiteConfigSelectors.selectCurrentSite);

  if (!currentSite || !currentSite.code) {
    throw new Error('Current site expected but missing!');
  }

  return currentSite;
}

export function useCurrentSiteCode(): string {
  const currentSite = useCurrentSite();
  return currentSite.code;
}
